import React from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { ServerMessageHandler } from '@swf/notification';

import type { DepositPayload } from '../../../types/Cashier';
import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Continue_without_bonus,
  TXTWCL_Increase_deposit_amount,
  TXTWCL_Still_want_to_claim_your_bonus_ELL
} from './RejectedBonusMinDeposit.messages.json';

interface Props {
  defaultMessage: string;
  deposit: DepositPayload;
  onClose(): void;
}

const RejectedBonusMinDeposit: React.FC<Props> = ({ defaultMessage, deposit, onClose }) => {
  const form = useForm();
  const firstName = useSelector(select.account.getFirstName) as string;

  return (
    <Prompt
      variant="info"
      title={{
        translation: TXTWCL_Still_want_to_claim_your_bonus_ELL,
        values: { '0': firstName }
      }}
      primaryButton={{
        translation: TXTWCL_Increase_deposit_amount
      }}
      secondaryButton={{
        translation: TXTWCL_Continue_without_bonus
      }}
      alert={<ServerMessageHandler message={defaultMessage} />}
      onSecondaryButtonClick={() => {
        delete deposit.bonusCode;
        form.submit();
      }}
      onClose={onClose}
    />
  );
};

export default RejectedBonusMinDeposit;
